//import axios from 'axios';
import api from '../../api';


import {
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_MINE_LIST_FAIL,
  ORDER_MINE_LIST_REQUEST,
  ORDER_MINE_LIST_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_PAY_REQUEST,
  QUOTE_REQUEST_FAIL,
  QUOTE_REQUEST_START,
} from '../constant/orderConstant';
import { CART_EMPTY } from '../constant/cartConstans';


export const createOrder = order => async (dispatch, getState) => {

  dispatch({ type: ORDER_CREATE_REQUEST, payload: order });
  try {
    const {
      userSignin: { userInfo },
    } = getState();


    //const { data } = await axios.post('/order/', order, {
    const { data } = await api.post('/order/', order, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });

    // Axios already parses JSON automatically, so data is already an object
    // No need to check data.ok or call data.json()

    ;

    dispatch({ type: ORDER_CREATE_SUCCESS, payload: data.order });
    //? control estas dos lineas estaban comentadas */
    dispatch({ type: CART_EMPTY });
    localStorage.removeItem('cartItems');
  } catch (error) {
    console.error('❌ Error creating order:', error);
    dispatch({
      type: ORDER_CREATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const detailsOrder = orderId => async (dispatch, getState) => {
  dispatch({ type: ORDER_DETAILS_REQUEST, payload: orderId });

  const {
    userSignin: { userInfo },
  } = getState();

  /*  { headers: { Authorization: \Bearer ${userInfo.token}` } }`
Esta parte define los encabezados de la solicitud HTTP.
El encabezado Authorization se establece con un token de autenticación. 
El valor del token se obtiene de la variable userInfo.token.
En resumen, esta línea de código realiza una solicitud GET a la ruta /order/${orderId} 
y espera a que se complete. Luego, extrae la propiedad data de la respuesta 
y almacena su valor en la variable data. Además, 
se incluye un encabezado de autorización con el token proporcionado en userInfo.*/

  try {
    //const { data } = await axios.get(`/order/${orderId}`, {
    const { data } = await api.get(`/order/${orderId}`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    dispatch({ type: ORDER_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: ORDER_DETAILS_FAIL, payload: message });
  }
};

export const requestQuote = orderId => async (dispatch, getState) => {


  dispatch({ type: QUOTE_REQUEST_START });

  const {
    userSignin: { userInfo },
  } = getState();


  try {
    const timestamp = Date.now();


    const payload = {
      orderId,

    };

    //const response = await axios.post('/order/request-quote', payload, {
    const response = await api.post('/order/request-quote', payload, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });

    dispatch({
      type: QUOTE_REQUEST_SUCCESS,
      payload: response.data.message || 'Cotizacion solicitada con exito ',
    });
  } catch (error) {
    const apiError =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: QUOTE_REQUEST_FAIL,
      payload: apiError || 'Error de conexion intentalo de nuevo',
    });
  }
};

export const payOrder =
  (orderId, paymentResult) => async (dispatch, getState) => {
    dispatch({ type: ORRDER_PAY_REQUEST, payload: { orderId, paymentResult } });
    const {
      userSignin: { userInfo },
    } = getState();
    try {
      //  const { data } = await axios.put(`/order/${orderId}/pay`, paymentResult, {
      const { data } = await api.put(`/order/${orderId}/pay`, paymentResult, {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      });
      dispatch({ type: ORDER_PAY_SUCCESS, payload: data });
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({ type: ORDER_PAY_FAIL, payload: message });
    }
  };

export const listOrderMine = () => async (dispatch, getState) => {
  dispatch({ type: ORDER_MINE_LIST_REQUEST });
  const {
    userSignin: { userInfo },
  } = getState();


  try {
    //const { data } = await axios.get('/order/mine', {
    const { data } = await api.get('/order/mine', {
      headers: { Authorization: `Bearer ${userInfo.token}` },
    });
    dispatch({ type: ORDER_MINE_LIST_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({ type: ORDER_MINE_LIST_FAIL, payload: message });
  }
};
